const BannerTypeEnum = {
  LOGIN: 0,
  NETWORKS: 1,
};

const BannerTypeLabel = new Map([
  [BannerTypeEnum.LOGIN, 'Tela de Login'],
  [BannerTypeEnum.NETWORKS, 'Redes Específicas'],
]);

export { BannerTypeEnum, BannerTypeLabel };
